/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { CSSProperties, forwardRef } from "react";
import Spinners from "react-spinners/BeatLoader";
import ImageUnavailableIcon from "../../assets/icons/img-unavailable.svg";

interface ViewerLoaderProps {
  children: React.ReactElement | React.ReactElement[];
  className?: string;
  loading?: boolean;
  isShowNoViewer?: boolean;
  dark?: boolean;
}
const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  opacity: "0.5",
  zIndex: 9999,
};

export const ViewerLoader = forwardRef<HTMLDivElement, ViewerLoaderProps>(
  (
    {
      children,
      className = "",
      loading = false,
      isShowNoViewer = false,
      dark = false,
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={`image-loading-wrapper w-100 h-100  ${className}`}
      >
        {isShowNoViewer && (
          <div
            className={`w-100 h-100 d-flex flex-center flex-direction-column ${
              dark ? "no-image-bg-dark" : "no-image-bg-light"
            }`}
          >
            <img src={ImageUnavailableIcon} alt="Image No Available" />
            <span className="m-t-xs text-white">No Image Available</span>
          </div>
        )}
        <Spinners
          color="#289f68"
          size={8}
          loading={loading}
          cssOverride={override}
          aria-label="Loading ..."
        />
        {!isShowNoViewer && children}
      </div>
    );
  }
);
